import { Tooltip } from "react-bootstrap";

export const renderToolTip = (type, object) => {
    let tooltip;
    if(global.config.dashboard.tooltips === false) {
        type = "disabled";
    }
    switch(type) {
        case "instanceUserChange": 
            tooltip = (
                <Tooltip id="tooltip">
                    <strong>{object.instance} (Total Sign-Ins)</strong> <br/>
                    Last Month: {object.totalLastPeriod} <br/>
                    This Month: {object.totalThisPeriod}
                </Tooltip>
            );
            break;
        case "instanceNoticeChange": 
            tooltip = (
                <Tooltip id="tooltip">
                    <strong>{object.instance} (Total Notices)</strong> <br/>
                    Last Month: {object.totalLastPeriod} <br/>
                    This Month: {object.totalThisPeriod}
                </Tooltip>
            );
            break;
        // Simply add a new case for each tooltip added.
        // Must be enabled via config.
        default:
             tooltip = (
                <></>
            );
            break;
    }
    return tooltip;
}